module.exports = __webpack_public_path__ + "static/img/mcn_pic1.ecf79310.png";